import React, { useEffect, useState } from 'react';
import Line from '../shared/Line';
import { fetchBillsByStatus } from '../../utils/apis';
import LoadingOverlay from '../insurance/LoadingOverlay';
import { useNavigate } from "react-router-dom";
import BillTable from './table';
interface BillData {
  id: number;
  amount: number;
  dueDate: string;
  status: string;
  providerId: string;
  providerName?: string;
  providerAddress?: string;
  userName?: string;
  userEmail?: string;
  userPhoneNumber?: string;
  statementDate?: string;
  invoiceLink?: string;
  comment?: string;
  jsonData?: string;
  patientName?: string;
  patientAddress?: string;
  userSaved?: boolean;
  firstName?: string;
  lastName?: string;
  paymentDate?: string;
  isPaid?: boolean;
}

const MyBills: React.FC = () => {
  const [bills, setBills] = useState<BillData[]>([]);
  const [paidBills, setPaidBills] = useState<BillData[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  useEffect(() => {
    const fetchBills = async () => {
      try {
        setLoading(true);
        const response = await fetchBillsByStatus(); // Replace with actual API endpoint
        setBills([ ...response?.receiptsByProvider]);
      } catch (error) {
        console.error('Error fetching bills:', error);
      } finally {
        setLoading(false);
      }
    };
    const fetchPaidBills = async () => {
      try {
        setLoading(true);
        const response = await fetchBillsByStatus("Paid"); // Replace with actual API endpoint
        setPaidBills([ ...response?.receiptsByProvider]);
      } catch (error) {
        console.error('Error fetching bills:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchBills();
    fetchPaidBills();
  }, []);

  const handleCardClick = (bill: BillData) => {
    navigate("/statement", { state: { bill } });
  };

  if(loading) {
    return <LoadingOverlay />
  }

  return (
    <div className="p-6 bg-gray-100 rounded-lg">
      <div className="flex flex-wrap gap-4">
        {bills.length > 0 ? (
          <BillTable rows={bills} heading="Pending Bills" handlePaymentClick={handleCardClick} />
        ) : (
          <div className="text-gray-500">No bills available.</div>
        )}
      </div>
      <div className="my-4">
        <Line height="2px" />
      </div>
      <div className="flex flex-wrap gap-4">
      {
        <BillTable rows={paidBills} heading="Paid Bills" showActionButton={false}  />
      }
      </div>
      {/*
      
      <div className="flex flex-wrap justify-between gap-4 mt-8">
         <ActionButton
          icon={<MagicStar />}
          label="Upload Bill"
          onClick={() => console.log('Upload Bill clicked')}
        /> 
        <ActionButton
          icon={<MagicStar />}
          label="Payment History"
          onClick={() => console.log('Payment History clicked')}
        /> 
      </div>
      */}
    </div>
  );
};

export default MyBills;
